import styled, { css } from 'styled-components';
import { TooltipContent } from '@radix-ui/react-tooltip';

export const Container = styled.div`
  flex-direction: row;
  display: flex;
`;

export const ImgWrapper = styled.div`
  padding-left: 5px;
`;

export const Image = styled.img`
  width: 40px;
  height: 40px;
`;

export const Message = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 1.5em;
  & > strong {
    font-size: 0.75rem;
    line-height: 1em;
  }
  ${({ isHidden }) =>
    isHidden &&
    css`
      align-items: flex-start;
      justify-content: flex-start;
      text-align: start;
    `}
`;

export const Messages = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const CustomRadixContent = styled(TooltipContent)`
  max-width: 300px;
  padding: 12px 14px;
  font: 400 normal 0.625rem/1em 'Nunito', sans-serif;
  background-color: #171c24;
  color: #fff;
  border-radius: 4px;
  white-space: nowrap;
`;
